// extracted by mini-css-extract-plugin
export var deleteModal = "_h1-0";